<script setup lang="ts">
import type { Attr } from "~/types";
import { SekouSearchAttrs } from "#components";
import { useModal } from "vue-final-modal";
const attrs = inject<Attr[]>("attrs", []);

// 詳しく絞り込むモーダル定義
const { open, close } = useModal({
  component: SekouSearchAttrs,
  attrs: {
    attrs,
    onClose: () => {
      close();
    },
  },
});
</script>

<template>
  <button
    class="w-full flex justify-center items-center p-2 rounded text-white bg-[#0061FE] hover:bg-[#0061fec3]"
    @click="open"
  >
    <Icon class="mr-2" size="18" name="mdi:filter" />
    <slot>絞り込む</slot>
  </button>
</template>
